<app-navbar>
  <main class="flex-1 overflow-y-auto relative pb-16">
    <div class="w-full px-4 py-6">
      <router-outlet></router-outlet>
    </div>
    
    <footer class="absolute bottom-4 left-6 text-xs text-base-content/40 select-none pointer-events-none">
      © 2026 © ColoClic - La Colonial, S.A. Compañía de Seguros.
    </footer>
  </main>
</app-navbar>

